import React from 'react'

import type { IColors } from '../../styles/styled'
import { Environment, getEnvironment } from '../../util/env'
import { BadgeWrapper, InlineBadge } from './styles'
import { IProps } from './types'

const ENVIRONMENT_BADGE: Record<
	Exclude<Environment, 'prod'>,
	{ label: string; color: keyof IColors }
> = {
	local: { label: 'local', color: 'red' },
	dev: { label: 'dev', color: 'green' },
	stage: { label: 'stage', color: 'yellow' },
}

export default function EnvironmentBadge({
	fixed = false,
	withPrefix,
	className,
}: IProps): JSX.Element | null {
	const environment = getEnvironment()

	if (!environment || environment === 'prod') return null

	const { label, color } = ENVIRONMENT_BADGE[environment]

	const badge = (
		<BadgeWrapper
			$color={color}
			$fixed={fixed}
			className={withPrefix ? undefined : className}
		>
			<span className='dot' />
			<span className='label'>{label}</span>
		</BadgeWrapper>
	)

	if (!withPrefix) return badge

	return (
		<InlineBadge className={className}>
			<span className='prefix'>Você está no ambiente:</span>
			{badge}
		</InlineBadge>
	)
}
